import { useToast } from "@aircall/tractor";
import { useTranslation } from "react-i18next";

import { mapToCall } from "../../states/call/call.utility";

import { UseCallByIdQueryReturnType } from "./useCallByIdQuery.decl";

import {
  GetCallQuery,
  GetCallQueryVariables,
} from "@/graphql/generated/graphql";
import { GetCall } from "@/graphql/queries/GetCall";
import { useBaseStore } from "@/store/store";

import { useHasSentimentAnalysis } from "@/hooks/useHasSentimentAnalysis/useHasSentimentAnalysis";
import { useQueryWrapper } from "../useQueryWrapper/useQueryWrapper";
/**
 * The hook responsible for querying from server the call data and map it to the Call entity.
 * @param callId - id of call
 */
export function useCallByIdQuery(callId: string): UseCallByIdQueryReturnType {
  const { t } = useTranslation();

  const hasSentimentAnalysis = useHasSentimentAnalysis();
  const { showToast } = useToast();
  const setCall = useBaseStore((store) => store.setCall);

  const { data, loading, error } = useQueryWrapper<
    GetCallQuery,
    GetCallQueryVariables
  >(GetCall, {
    shouldThrowError: true,
    variables: {
      callId,
      skipSentiments: !hasSentimentAnalysis,
    },
    errorPolicy: "all",
    onCompleted: (data) => {
      if (!data?.getCall) {
        return;
      }
      const call = mapToCall(data.getCall);
      setCall(call);
    },
    onError: () =>
      showToast({
        variant: "critical",
        message: t("toast.fetch_failure"),
      }),
  });

  return {
    call: data?.getCall,
    loading,
    error,
  };
}
